
export * from './address-type.service';
export * from './common.service';
export * from './contact.service';

export * from './contract.service';
export * from './contract-template.service';
export * from './demarcation-list.service';

export * from './dataaccess.base.service';

export * from './file.service';
export * from './industry.service';


export * from './model-state-validation.service';
export * from './premises.service';
export * from './project.service';
export * from './store.service';
export * from './supplier.service';
export * from './supplier-address.service';
export * from './system-table.service';
export * from './area-planner.service';
export * from './support-data.service';

export * from './authentication/authentication.service';

export * from './api.service';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/index.ts